import { render, staticRenderFns } from "./DraggableCard.vue?vue&type=template&id=ddc866ec&scoped=true&lang=pug"
import script from "./DraggableCard.vue?vue&type=script&lang=js"
export * from "./DraggableCard.vue?vue&type=script&lang=js"
import style0 from "./DraggableCard.vue?vue&type=style&index=0&id=ddc866ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc866ec",
  null
  
)

export default component.exports